import { Integration } from "../../model/integration/Integration";
import { CreateIntegrationDto } from "../../model/integration/dto/CreateIntegrationDto";
import { DeleteIntegrationDto } from "../../model/integration/dto/DeleteIntegrationDto";
import { IntegrationFBFinishFieldResolveFinalizeDto } from "../../model/integration/dto/IntegrationFBFinishFieldResolveFinalizeDto";
import { IntegrationFBStartFieldResolveResponseDto } from "../../model/integration/dto/IntegrationFBStartFieldResolveResponseDto";
import { UpdateIntegrationDto } from "../../model/integration/dto/UpdateIntegrationDto";
import { WaslaConversationCreateNoteDto } from "../../model/integration/dto/WaslaConversationCreateNoteDto";
import { WaslaGetChatDetailsDto } from "../../model/integration/dto/WaslaGetChatDetailsDto";
import { WaslaGetChatDetailsResponseDto } from "../../model/integration/dto/WaslaGetChatDetailsResponseDto";
import { WaslaGetChatMessagesDto } from "../../model/integration/dto/WaslaGetChatMessagesDto";
import { WaslaGetChatMessagesResponseDto } from "../../model/integration/dto/WaslaGetChatMessagesResponseDto";
import { WaslaGetChatsListDto } from "../../model/integration/dto/WaslaGetChatsListDto";
import { WaslaGetChatsListResponseDto } from "../../model/integration/dto/WaslaGetChatsListResponseDto";
import { WaslaMarkChatAsReadDto } from "../../model/integration/dto/WaslaMarkChatAsReadDto";
import { WaslaSendChatMessageDto } from "../../model/integration/dto/WaslaSendChatMessageDto";
import { WhatsappDirectDisconnectDto } from "../../model/integration/dto/WhatsappDirectDisconnectDto";
import { WhatsappDirectGetQRDto } from "../../model/integration/dto/WhatsappDirectGetQRDto";
import { WhatsappDirectGetQRResponseDto } from "../../model/integration/dto/WhatsappDirectGetQRResponseDto";
import { WhatsappDirectSyncStatusDto } from "../../model/integration/dto/WhatsappDirectSyncStatusDto";
import { WhatsappMetaEmbeddedSignupFinalizeDto } from "../../model/integration/dto/WhatsappMetaEmbeddedSignupFinalizeDto";
import { WhatsappMetaEmbeddedSignupFinalizeResponseDto } from "../../model/integration/dto/WhatsappMetaEmbeddedSignupFinalizeResponseDto";
import { Conversation } from "../../model/integration/dto/meta/MetaConversation";
import { MetaConversationAssignDto } from "../../model/integration/dto/meta/MetaConversationAssignDto";
import { MetaConversationTagsDto } from "../../model/integration/dto/meta/MetaConversationTagsDto";
import { MetaConversationHandoverDto } from "../../model/integration/dto/meta/MetaConversationHandoverDto";
import { MetaCreateConversationDto } from "../../model/integration/dto/meta/MetaCreateConversationDto";
import { MetaGetChatDto } from "../../model/integration/dto/meta/MetaGetChatDto";
import { MetaGetChatsListDto } from "../../model/integration/dto/meta/MetaGetChatsListDto";
import { MetaGetChatsListResponseDto } from "../../model/integration/dto/meta/MetaGetChatsListResponseDto";
import { MetaGetMediaStorageDto } from "../../model/integration/dto/meta/MetaGetMediaStorageDto";
import { MetaGetNumberHealthDto } from "../../model/integration/dto/meta/MetaGetNumberHealthDto";
import { MetaMediaStorageResponseDto } from "../../model/integration/dto/meta/MetaMediaStorageResponseDto";
import { WhatsappCampaignActionDto } from "../../model/integration/dto/whatsapp-campaign/WhatsappCampaignActionDto";
import { WhatsappCampaignCreateDto } from "../../model/integration/dto/whatsapp-campaign/WhatsappCampaignCreateDto";
import { WhatsappCampaignDetailsResponseDto } from "../../model/integration/dto/whatsapp-campaign/WhatsappCampaignDetailsResponseDto";
import { WhatsappCampaignListDto } from "../../model/integration/dto/whatsapp-campaign/WhatsappCampaignListDto";
import { WhatsappCampaignResponseDto } from "../../model/integration/dto/whatsapp-campaign/WhatsappCampaignResponseDto";
import { WhatsappCampaignUpdateDto } from "../../model/integration/dto/whatsapp-campaign/WhatsappCampaignUpdateDto";
import { MetaGetTemplatesDto } from "../../model/integration/dto/meta/MetaGetTemplatesDto";
import { MetaNumberHealthResponseDto } from "../../model/integration/dto/meta/MetaNumberHealthResponseDto";
import { MetaIncrementChatUnreadCountDto } from "../../model/integration/dto/meta/MetaIncrementChatUnreadCountDto";
import { MetaMarkChatAsReadDto } from "../../model/integration/dto/meta/MetaMarkChatAsReadDto";
import {
  MetaDeleteMessageDto,
  MetaReactToMessageDto,
} from "../../model/integration/dto/meta/MetaMessageActionDto";
import {
  MetaGetMessagesDto,
  MetaGetMessagesResponseDto,
} from "../../model/integration/dto/meta/MetaGetMessagesDto";
import { MetaMessageLoadImageDto } from "../../model/integration/dto/meta/MetaMessageLoadImage";
import { MetaSendMediaDto } from "../../model/integration/dto/meta/MetaSendMediaDto";
import { MetaSendMessageDto } from "../../model/integration/dto/meta/MetaSendMessageDto";
import { WhatsappMetaAIAgentDeleteDto } from "../../model/integration/dto/meta/WhatsappMetaAIAgentDeleteDto";
import { WhatsappMetaAIAgentDto } from "../../model/integration/dto/meta/WhatsappMetaAIAgentDto";
import { WhatsappMetaAutoAssignDto } from "../../model/integration/dto/meta/WhatsappMetaAutoAssignDto";
import { ConversationComment } from "../../model/integration/dto/meta/MetaConversationComment";
import { MetaConversationCommentsDto } from "../../model/integration/dto/meta/MetaConversationCommentsDto";
import { MetaConversationCommentsResponseDto } from "../../model/integration/dto/meta/MetaConversationCommentsResponseDto";
import { MetaConversationCommentCreateDto } from "../../model/integration/dto/meta/MetaConversationCommentCreateDto";
import { MetaConversationCommentUpdateDto } from "../../model/integration/dto/meta/MetaConversationCommentUpdateDto";
import { MetaConversationCommentDeleteDto } from "../../model/integration/dto/meta/MetaConversationCommentDeleteDto";
import { FacebookMetaConnectDto } from "../../model/integration/dto/facebook-meta/FacebookMetaConnectDto";
import { FacebookMetaFetchLeadsDto } from "../../model/integration/dto/facebook-meta/FacebookMetaFetchLeadsDto";
import { FacebookMetaFetchLeadsResponseDto } from "../../model/integration/dto/facebook-meta/FacebookMetaFetchLeadsResponseDto";
import { FacebookMetaListFormsResponseDto } from "../../model/integration/dto/facebook-meta/FacebookMetaListFormsResponseDto";
import { FacebookMetaLinkFormDto } from "../../model/integration/dto/facebook-meta/FacebookMetaLinkFormDto";
import { FacebookMetaListFormsDto } from "../../model/integration/dto/facebook-meta/FacebookMetaListFormsDto";
import { FacebookMetaUnlinkFormDto } from "../../model/integration/dto/facebook-meta/FacebookMetaUnlinkFormDto";
import { IntegrationConfigFacebookMeta } from "../../model/integration/types/config/IntegrationConfigFacebookMeta";
import { GoogleDriveCallbackDto } from "../../model/integration/dto/google-drive/GoogleDriveCallbackDto";
import { GoogleDriveCallbackResponseDto } from "../../model/integration/dto/google-drive/GoogleDriveCallbackResponseDto";
import { GoogleDriveCreateFileDto } from "../../model/integration/dto/google-drive/GoogleDriveCreateFileDto";
import { GoogleDriveFileDto } from "../../model/integration/dto/google-drive/GoogleDriveFileDto";
import { GoogleDriveFileOrDeleteDto } from "../../model/integration/dto/google-drive/GoogleDriveFileOrDeleteDto";
import { GoogleDriveListFilesDto } from "../../model/integration/dto/google-drive/GoogleDriveListFilesDto";
import { GoogleDrivePickerRootsDto } from "../../model/integration/dto/google-drive/GoogleDrivePickerRootsDto";
import { GoogleDriveUpdateFileDto } from "../../model/integration/dto/google-drive/GoogleDriveUpdateFileDto";
import { IntegrationConfigGoogleDrive } from "../../model/integration/types/config/IntegrationConfigGoogleDrive";
import { GenericWithUserId } from "../../model/shared/dto/GenericWithUserId";
import { AtiraApi } from "../AxiosClient";

export const WHATSAPP_CHATS_PAGE_SIZE = 50;

export class IntegrationAxios {
  static createIntegration(dto: CreateIntegrationDto<any>) {
    return AtiraApi.post<void>(`/integration/create`, dto).then(
      ({ data }) => data,
    );
  }

  static disconnectIntegration(dto: DeleteIntegrationDto) {
    return AtiraApi.delete<void>(
      `/integration/${dto.integrationId}/disconnect`,
      { data: dto },
    ).then(({ data }) => data);
  }

  static getUserIntegrations(dto: GenericWithUserId) {
    return AtiraApi.post<Integration<any>[]>(
      `/integration/${dto.userId}`,
      dto,
    ).then(({ data }) => data);
  }

  static startFBWebhookFinalizeFields(integrationId: string) {
    return AtiraApi.post<IntegrationFBStartFieldResolveResponseDto>(
      `/integration/${integrationId}/start-fields-resolve`,
    ).then(({ data }) => data);
  }

  static finishFBWebhookFinalizeFields(
    dto: IntegrationFBFinishFieldResolveFinalizeDto,
  ) {
    return AtiraApi.post<void>(
      `/integration/${dto.integrationId}/finish-fields-resolve`,
      dto,
    ).then(({ data }) => data);
  }

  static updateIntegration(dto: UpdateIntegrationDto<any>) {
    return AtiraApi.patch<void>(
      `/integration/${dto.integrationId}/update`,
      dto,
    ).then(({ data }) => data);
  }

  static finalizeWhatsappMetaEmbeddedSignup(
    dto: WhatsappMetaEmbeddedSignupFinalizeDto,
  ) {
    return AtiraApi.post<WhatsappMetaEmbeddedSignupFinalizeResponseDto>(
      `/integration/whatsapp-meta/embedded-signup/finalize`,
      dto,
    ).then(({ data }) => data);
  }

  static getWhatsAppDirectQR(dto: WhatsappDirectGetQRDto) {
    return AtiraApi.post<WhatsappDirectGetQRResponseDto>(
      `/integration/whatsapp-direct/${dto.integrationId}/get-qr`,
      dto,
    ).then(({ data }) => data);
  }

  static syncWhatsappDirectStatus(dto: WhatsappDirectSyncStatusDto) {
    return AtiraApi.post<void>(
      `/integration/whatsapp-direct/${dto.integrationId}/sync-status`,
      dto,
    ).then(({ data }) => data);
  }

  static getWhatsAppDirectChatsList(dto: WaslaGetChatsListDto) {
    return AtiraApi.post<WaslaGetChatsListResponseDto>(
      `/integration/whatsapp-direct/${dto.integrationId}/chats-list`,
      dto,
    ).then(({ data }) => data);
  }

  static getWhatsAppDirectChatDetails(dto: WaslaGetChatDetailsDto) {
    return AtiraApi.post<WaslaGetChatDetailsResponseDto>(
      `/integration/whatsapp-direct/${dto.integrationId}/chats-list/${dto.chatId}/details`,
      dto,
    ).then(({ data }) => data);
  }

  static getWhatsAppDirectChatMessages(dto: WaslaGetChatMessagesDto) {
    return AtiraApi.post<WaslaGetChatMessagesResponseDto>(
      `/integration/whatsapp-direct/${dto.integrationId}/chats-list/${dto.chatId}/messages`,
      dto,
    ).then(({ data }) => data);
  }

  static sendWhatsAppDirectMessage(dto: WaslaSendChatMessageDto) {
    return AtiraApi.post<void>(
      `/integration/whatsapp-direct/${dto.integrationId}/chats-list/${dto.to}/send-message`,
      dto,
    ).then(({ data }) => data);
  }

  static disconnectWhatsAppDirect(dto: WhatsappDirectDisconnectDto) {
    return AtiraApi.delete<void>(
      `/integration/whatsapp-direct/${dto.integrationId}/disconnect`,
      { data: dto },
    ).then(({ data }) => data);
  }

  static markChatAsRead(dto: WaslaMarkChatAsReadDto) {
    return AtiraApi.post<void>(
      `/integration/whatsapp-direct/${dto.integrationId}/chats-list/${dto.chatId}/mark-as-read`,
      dto,
    ).then(({ data }) => data);
  }

  static createWhatsAppNote(dto: WaslaConversationCreateNoteDto) {
    return AtiraApi.post<void>(
      `/integration/whatsapp-direct/${dto.integrationId}/chats-list/${dto.chatId}/atira-actions/notes/create`,
      dto,
    ).then(({ data }) => data);
  }

  //

  static getWhatsAppMetaChatsList(dto: MetaGetChatsListDto) {
    return AtiraApi.post<MetaGetChatsListResponseDto>(
      `/integration/whatsapp-meta/${dto.integrationId}/chats-list`,
      { ...dto, limit: dto.limit ?? WHATSAPP_CHATS_PAGE_SIZE },
    ).then(({ data }) => data);
  }

  static getWhatsAppMetaChat(dto: MetaGetChatDto) {
    return AtiraApi.post<Conversation>(
      `/integration/whatsapp-meta/${dto.integrationId}/chats-list/${dto.conversationId}`,
      dto,
    ).then(({ data }) => data);
  }

  static sendWhatsAppMetaMessage(dto: MetaSendMessageDto) {
    return AtiraApi.post<void>(
      `/integration/whatsapp-meta/${dto.integrationId}/chats-list/${dto.conversationId}/send-message`,
      dto,
    ).then(({ data }) => data);
  }

  static getWhatsAppMetaTemplates(dto: MetaGetTemplatesDto) {
    return AtiraApi.post<any>(
      `/integration/whatsapp-meta/${dto.integrationId}/templates`,
      dto,
    ).then(({ data }) => data);
  }

  static getWhatsAppMetaNumberHealth(dto: MetaGetNumberHealthDto) {
    return AtiraApi.post<MetaNumberHealthResponseDto>(
      `/integration/whatsapp-meta/${dto.integrationId}/number-health`,
      dto,
    ).then(({ data }) => data);
  }

  static getWhatsAppMetaMediaStorage(dto: MetaGetMediaStorageDto) {
    return AtiraApi.post<MetaMediaStorageResponseDto>(
      `/integration/whatsapp-meta/${dto.integrationId}/media-storage`,
      dto,
    ).then(({ data }) => data);
  }

  static getWhatsappMetaCampaigns(dto: WhatsappCampaignListDto) {
    return AtiraApi.post<WhatsappCampaignResponseDto[]>(
      `/integration/whatsapp-meta/${dto.integrationId}/campaigns`,
      dto,
    ).then(({ data }) => data);
  }

  static getWhatsappMetaCampaign(dto: WhatsappCampaignActionDto) {
    return AtiraApi.post<WhatsappCampaignDetailsResponseDto>(
      `/integration/whatsapp-meta/${dto.integrationId}/campaigns/${dto.campaignId}`,
      dto,
    ).then(({ data }) => data);
  }

  static createWhatsappMetaCampaign(dto: WhatsappCampaignCreateDto) {
    return AtiraApi.post<void>(
      `/integration/whatsapp-meta/${dto.integrationId}/campaigns/create`,
      dto,
    ).then(({ data }) => data);
  }

  static updateWhatsappMetaCampaign(dto: WhatsappCampaignUpdateDto) {
    return AtiraApi.patch<void>(
      `/integration/whatsapp-meta/${dto.integrationId}/campaigns/${dto.campaignId}`,
      dto,
    ).then(({ data }) => data);
  }

  static pauseWhatsappMetaCampaign(dto: WhatsappCampaignActionDto) {
    return AtiraApi.post<void>(
      `/integration/whatsapp-meta/${dto.integrationId}/campaigns/${dto.campaignId}/pause`,
      dto,
    ).then(({ data }) => data);
  }

  static resumeWhatsappMetaCampaign(dto: WhatsappCampaignActionDto) {
    return AtiraApi.post<void>(
      `/integration/whatsapp-meta/${dto.integrationId}/campaigns/${dto.campaignId}/resume`,
      dto,
    ).then(({ data }) => data);
  }

  static deleteWhatsappMetaCampaign(dto: WhatsappCampaignActionDto) {
    return AtiraApi.delete<void>(
      `/integration/whatsapp-meta/${dto.integrationId}/campaigns/${dto.campaignId}`,
      { data: dto },
    ).then(({ data }) => data);
  }

  static getMetaChatMedia(dto: MetaMessageLoadImageDto) {
    return AtiraApi.post<Blob>(
      `/integration/whatsapp-meta/${dto.integrationId}/chats-list/${dto.conversationId}/media/load-media`,
      dto,
      { responseType: "blob" },
    ).then(({ data }) => {
      return URL.createObjectURL(data);
    });
  }

  static markWhatsAppMetaChatAsRead(dto: MetaMarkChatAsReadDto) {
    return AtiraApi.post<void>(
      `/integration/whatsapp-meta/${dto.integrationId}/chats-list/${dto.conversationId}/mark-as-read`,
      dto,
    ).then(({ data }) => data);
  }

  static incrementWhatsAppMetaChatUnreadCount(
    dto: MetaIncrementChatUnreadCountDto,
  ) {
    return AtiraApi.post<void>(
      `/integration/whatsapp-meta/${dto.integrationId}/chats-list/${dto.conversationId}/increment-unread-count`,
      dto,
    ).then(({ data }) => data);
  }

  static createWhatsappMetaConversation(dto: MetaCreateConversationDto) {
    return AtiraApi.post<Conversation>(
      `/integration/whatsapp-meta/${dto.integrationId}/chats-list/create-conversation`,
      dto,
    ).then(({ data }) => data);
  }

  static sendWhatsappMetaMedia(dto: MetaSendMediaDto) {
    const form = new FormData();

    form.append("file", dto.file);
    form.append("userId", dto.userId);
    form.append("integrationId", dto.integrationId);
    form.append("conversationId", dto.conversationId);

    if (dto.caption) {
      form.append("caption", dto.caption);
    }

    if (dto.voice) {
      form.append("voice", "true");
    }

    if (dto.clientId) {
      form.append("clientId", dto.clientId);
    }

    if (dto.contextMessageId) {
      form.append("contextMessageId", dto.contextMessageId);
    }

    return AtiraApi.post<void>(
      `/integration/whatsapp-meta/${dto.integrationId}/chats-list/${dto.conversationId}/media/send`,
      form,
    ).then(({ data }) => data);
  }

  static showWhatsappMetaTyping(dto: {
    userId: string;
    integrationId: string;
    conversationId: string;
  }) {
    return AtiraApi.post<void>(
      `/integration/whatsapp-meta/${dto.integrationId}/chats-list/${dto.conversationId}/typing`,
      dto,
    ).then(({ data }) => data);
  }

  static getWhatsappMetaMessages(dto: MetaGetMessagesDto) {
    return AtiraApi.post<MetaGetMessagesResponseDto>(
      `/integration/whatsapp-meta/${dto.integrationId}/chats-list/${dto.conversationId}/messages`,
      dto,
    ).then(({ data }) => data);
  }

  static deleteWhatsappMetaMessage(dto: MetaDeleteMessageDto) {
    return AtiraApi.delete<void>(
      `/integration/whatsapp-meta/${dto.integrationId}/chats-list/${dto.conversationId}/messages/${dto.messageId}`,
      { data: dto },
    ).then(({ data }) => data);
  }

  static reactToWhatsappMetaMessage(dto: MetaReactToMessageDto) {
    return AtiraApi.post<void>(
      `/integration/whatsapp-meta/${dto.integrationId}/chats-list/${dto.conversationId}/messages/${dto.messageId}/react`,
      dto,
    ).then(({ data }) => data);
  }

  static updateWhatsappMetaAIAgent(dto: WhatsappMetaAIAgentDto) {
    return AtiraApi.patch<void>(
      `/integration/whatsapp-meta/${dto.integrationId}/ai-agent`,
      dto,
    ).then(({ data }) => data);
  }

  static deleteWhatsappMetaAIAgent(dto: WhatsappMetaAIAgentDeleteDto) {
    return AtiraApi.delete<void>(
      `/integration/whatsapp-meta/${dto.integrationId}/ai-agent`,
      { data: dto },
    ).then(({ data }) => data);
  }

  static setWhatsappMetaConversationHandler(dto: MetaConversationHandoverDto) {
    return AtiraApi.post<void>(
      `/integration/whatsapp-meta/${dto.integrationId}/chats-list/${dto.conversationId}/handover`,
      dto,
    ).then(({ data }) => data);
  }

  static updateWhatsappMetaConversationTags(dto: MetaConversationTagsDto) {
    return AtiraApi.patch<void>(
      `/integration/whatsapp-meta/${dto.integrationId}/chats-list/${dto.conversationId}/tags`,
      dto,
    ).then(({ data }) => data);
  }

  static assignWhatsappMetaConversation(dto: MetaConversationAssignDto) {
    return AtiraApi.post<void>(
      `/integration/whatsapp-meta/${dto.integrationId}/chats-list/${dto.conversationId}/manage-assignees`,
      dto,
    ).then(({ data }) => data);
  }

  static updateWhatsappMetaAutoAssign(dto: WhatsappMetaAutoAssignDto) {
    return AtiraApi.patch<void>(
      `/integration/whatsapp-meta/${dto.integrationId}/auto-assign`,
      dto,
    ).then(({ data }) => data);
  }

  static getWhatsappMetaComments(dto: MetaConversationCommentsDto) {
    return AtiraApi.post<MetaConversationCommentsResponseDto>(
      `/integration/whatsapp-meta/${dto.integrationId}/chats-list/${dto.conversationId}/comments`,
      dto,
    ).then(({ data }) => data);
  }

  static createWhatsappMetaComment(dto: MetaConversationCommentCreateDto) {
    return AtiraApi.post<ConversationComment>(
      `/integration/whatsapp-meta/${dto.integrationId}/chats-list/${dto.conversationId}/comments/create`,
      dto,
    ).then(({ data }) => data);
  }

  static updateWhatsappMetaComment(dto: MetaConversationCommentUpdateDto) {
    return AtiraApi.patch<ConversationComment>(
      `/integration/whatsapp-meta/${dto.integrationId}/chats-list/${dto.conversationId}/comments/${dto.commentId}`,
      dto,
    ).then(({ data }) => data);
  }

  static deleteWhatsappMetaComment(dto: MetaConversationCommentDeleteDto) {
    return AtiraApi.delete<void>(
      `/integration/whatsapp-meta/${dto.integrationId}/chats-list/${dto.conversationId}/comments/${dto.commentId}`,
      { data: dto },
    ).then(({ data }) => data);
  }

  //

  static createGoogleDriveAuthLink(dto: GenericWithUserId) {
    return AtiraApi.post<string>(
      `/integration/google-drive/auth-link`,
      dto,
    ).then(({ data }) => data);
  }

  static googleDriveOAuthCallback(dto: GoogleDriveCallbackDto) {
    return AtiraApi.post<GoogleDriveCallbackResponseDto>(
      `/integration/google-drive/callback`,
      dto,
    ).then(({ data }) => data);
  }

  static getGoogleDriveIntegration(dto: GenericWithUserId) {
    return AtiraApi.post<Integration<IntegrationConfigGoogleDrive> | null>(
      `/integration/google-drive`,
      dto,
    ).then(({ data }) => data);
  }

  static registerGoogleDrivePickerRoots(dto: GoogleDrivePickerRootsDto) {
    return AtiraApi.post<Integration<IntegrationConfigGoogleDrive>>(
      `/integration/google-drive/${dto.integrationId}/picker-roots`,
      dto,
    ).then(({ data }) => data);
  }

  static disconnectGoogleDrive(dto: DeleteIntegrationDto) {
    return AtiraApi.post<void>(
      `/integration/google-drive/${dto.integrationId}/disconnect`,
      dto,
    ).then(({ data }) => data);
  }

  static connectFacebookMeta(dto: FacebookMetaConnectDto) {
    return AtiraApi.post<Integration<IntegrationConfigFacebookMeta>>(
      `/integration/facebook-meta/connect`,
      dto,
    ).then(({ data }) => data);
  }

  static getFacebookMetaForms(dto: FacebookMetaListFormsDto) {
    return AtiraApi.post<FacebookMetaListFormsResponseDto>(
      `/integration/facebook-meta/forms`,
      dto,
    ).then(({ data }) => data);
  }

  static linkFacebookMetaForm(dto: FacebookMetaLinkFormDto) {
    return AtiraApi.post<void>(
      `/integration/facebook-meta/forms/link`,
      dto,
    ).then(({ data }) => data);
  }

  static unlinkFacebookMetaForm(dto: FacebookMetaUnlinkFormDto) {
    return AtiraApi.post<void>(
      `/integration/facebook-meta/forms/unlink`,
      dto,
    ).then(({ data }) => data);
  }

  static fetchFacebookMetaLeads(dto: FacebookMetaFetchLeadsDto) {
    return AtiraApi.post<FacebookMetaFetchLeadsResponseDto>(
      `/integration/facebook-meta/forms/fetch-leads`,
      dto,
    ).then(({ data }) => data);
  }

  static listGoogleDriveFiles(dto: GoogleDriveListFilesDto) {
    return AtiraApi.post<GoogleDriveFileDto[]>(
      `/integration/google-drive/${dto.integrationId}/files`,
      dto,
    ).then(({ data }) => data);
  }

  static createGoogleDriveFile(dto: GoogleDriveCreateFileDto) {
    if (dto.file) {
      const form = new FormData();

      form.append("file", dto.file);
      form.append("userId", dto.userId);
      form.append("integrationId", dto.integrationId);
      form.append("name", dto.name);
      form.append("parentId", dto.parentId);

      return AtiraApi.post<GoogleDriveFileDto>(
        `/integration/google-drive/${dto.integrationId}/files/create`,
        form,
      ).then(({ data }) => data);
    }

    return AtiraApi.post<GoogleDriveFileDto>(
      `/integration/google-drive/${dto.integrationId}/files/create`,
      dto,
    ).then(({ data }) => data);
  }

  static updateGoogleDriveFile(dto: GoogleDriveUpdateFileDto) {
    return AtiraApi.patch<GoogleDriveFileDto>(
      `/integration/google-drive/${dto.integrationId}/files/${dto.fileId}`,
      dto,
    ).then(({ data }) => data);
  }

  static deleteGoogleDriveFile(dto: GoogleDriveFileOrDeleteDto) {
    return AtiraApi.delete<void>(
      `/integration/google-drive/${dto.integrationId}/files/${dto.fileId}`,
      { data: dto },
    ).then(({ data }) => data);
  }

  static downloadGoogleDriveFile(dto: GoogleDriveFileOrDeleteDto) {
    return AtiraApi.post<Blob>(
      `/integration/google-drive/${dto.integrationId}/files/${dto.fileId}/download`,
      dto,
      { responseType: "blob" },
    ).then(({ data }) => data);
  }
}
